import * as _tKeys from './source/i18nKeys';

export * from './logic';
export * from './source/i18nKeys';

type WidenLeafNodesToString<T> = {
  [K in keyof T]: T[K] extends object ? WidenLeafNodesToString<T[K]> : T[K];
} & {
  [key: string]: string;
};

const tKeysLoose = _tKeys.i18nKeys as WidenLeafNodesToString<typeof _tKeys.i18nKeys>;
const tKeys = _tKeys.i18nKeys;
export { tKeys, tKeysLoose };
